var _rect, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEventLogInactive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 34,
    height: 34,
    rx: 3.5,
    fill: "none",
    stroke: "currentColor"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 7,
    x2: 20,
    y2: 7,
    fill: "none",
    stroke: "currentColor"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 7,
    x2: 28,
    y2: 7,
    fill: "none",
    stroke: "currentColor"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 12,
    x2: 20,
    y2: 12,
    fill: "none",
    stroke: "currentColor"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 12,
    x2: 28,
    y2: 12,
    fill: "none",
    stroke: "currentColor"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 17,
    x2: 20,
    y2: 17,
    fill: "none",
    stroke: "currentColor"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 17,
    x2: 28,
    y2: 17,
    fill: "none",
    stroke: "currentColor"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 22,
    x2: 20,
    y2: 22,
    fill: "none",
    stroke: "currentColor"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 22,
    x2: 28,
    y2: 22,
    fill: "none",
    stroke: "currentColor"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 27,
    x2: 20,
    y2: 27,
    fill: "none",
    stroke: "currentColor"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 27,
    x2: 28,
    y2: 27,
    fill: "none",
    stroke: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventLogInactive);
export default __webpack_public_path__ + "static/media/event-log-inactive.cd24578dc6cd8f4e49e5e29bd024b822.svg";
export { ForwardRef as ReactComponent };